export default {
  initialize(owner) {
    owner.lookup("service:keyboard-shortcuts");
  },
};
